import { PlayerLogLevel } from "@blacknut/javascript-sdk/dist";
import { logD, logger, LogLevel } from "@blacknut/logging/dist";
import { useEffect } from "react";
import { useAppContext } from "../../utils/ContextProvider";
import { LOGGING_TAG } from "../../utils/logging";

export default () => {
  const { config } = useAppContext();
  useEffect(() => {
    const level = config?.userConf?.levelLogPlayer;
    if (level) {
      let loggerLevel = logger.level;
      switch (level) {
        case PlayerLogLevel.DEBUG:
        case PlayerLogLevel.TRACE:
          loggerLevel = LogLevel.LEVEL_DEBUG;
          break;
        case PlayerLogLevel.INFO:
          loggerLevel = LogLevel.LEVEL_INFO;
          break;
        case PlayerLogLevel.WARN:
          loggerLevel = LogLevel.LEVEL_WARN;
          break;
      }
      logD(LOGGING_TAG, "Overriding log level to %o (%o)", level, loggerLevel);
      logger.level = loggerLevel;
      logger.appenders.forEach((app) => (app.level = loggerLevel));
    }
  }, [config]);
};
